module.exports = __webpack_public_path__ + "static/media/map-marker-doctors.993bbe3a.svg";